var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVendors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2292 9.49425L27.2293 9.49444C28.4233 11.3991 27.3151 13.9348 25.2302 14.2137C25.0702 14.235 24.9101 14.2457 24.7409 14.2457C23.7 14.2457 22.7724 13.7881 22.1272 13.0716L21.5683 12.4509L21.0111 13.0731C20.3713 13.7876 19.4447 14.2457 18.3988 14.2457C17.3567 14.2457 16.4259 13.7873 15.7864 13.0731L15.2277 12.4492L14.6689 13.0731C14.0291 13.7876 13.1025 14.2457 12.0566 14.2457C11.0145 14.2457 10.0838 13.7873 9.44419 13.0731L8.88547 12.4492L8.32676 13.0731C7.68691 13.7876 6.76031 14.2457 5.71438 14.2457C5.54942 14.2457 5.38523 14.235 5.22584 14.2137C3.14976 13.9313 2.04431 11.3956 3.23473 9.49425C3.23476 9.49421 3.23478 9.49417 3.23481 9.49413L6.0234 5.04269L6.0242 5.04142C6.13579 4.86248 6.33723 4.75 6.55227 4.75H23.9116C24.1267 4.75 24.3281 4.86248 24.4397 5.04142L24.4405 5.04269L27.2292 9.49425Z",
    stroke: "#AAAFAF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.482 16.2117C23.8945 16.3105 24.3199 16.375 24.7496 16.375C25.0117 16.375 25.2695 16.3578 25.5316 16.3234C25.7723 16.2933 26.0043 16.2375 26.2363 16.1687V24.625C26.2363 25.3855 25.6219 26 24.8613 26H5.61133C4.85078 26 4.23633 25.3855 4.23633 24.625V16.1687C4.46406 16.2332 4.70039 16.289 4.94102 16.3234C5.19453 16.3578 5.45664 16.375 5.71445 16.375C6.14414 16.375 6.56953 16.3062 6.98203 16.2117V20.5H23.482V16.2117Z",
    stroke: "#AAAFAF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendors);
export default __webpack_public_path__ + "static/media/vendors.9c11b1bc.svg";
export { ForwardRef as ReactComponent };